import { render, staticRenderFns } from "./adstxt.vue?vue&type=template&id=1353da56&scoped=true&"
import script from "./adstxt.vue?vue&type=script&lang=js&"
export * from "./adstxt.vue?vue&type=script&lang=js&"
import style0 from "./adstxt.vue?vue&type=style&index=0&id=1353da56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1353da56",
  null
  
)

export default component.exports